/**
 * 预览子组件-购买按钮组件
 * @author chenqunfeng
 * @since 18/06/05
 */

import * as ajax from '@fe/common/lib/ajax';
import debounce from '@fe/common/lib/debounce';
import Stat from '@fe/common/lib/stat';
import { getActivityConfig } from 'api/app';
import { getYouzanBill } from 'api/opf';
import hotImgLeft from 'assets/images/hot-left.png';
import hotImgRight from 'assets/images/hot-right.png';
// import classnames from 'classnames';
import PayDialog from 'components/paydialog';
// import FreeTrialBtn from 'components/preview/free-trial';
import toast from 'components/toast';
import StatParams from 'constants/stat-params.json5';
import { isShowRabbitpre } from 'utils/env';
import {
  BLOCKED_CODE,
  BLOCKED_TEXT,
  CHAJIAN,
  ENTERPRISE,
  LOCAL_TEMPLATE,
  MY_TPL,
  RP_GAME,
} from 'constants/variable.json5';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { gotoEditor, sendStat } from 'utils/common';
import * as statisticSDK from 'utils/statisticSDK';
import { isAutoPay, isOrgUser } from 'utils/user';
import './buy-btn.less';

// 客服微信二维码
const qrcodePng = require('../../../assets/images/qrcode-weixin.png');

// 协议确定flag
let acceptProto = true;
class PreviewPrice extends Component {
  static propTypes = {
    data: PropTypes.object,
    coupon: PropTypes.object,
    buyState: PropTypes.object,
    userInfo: PropTypes.object,
    buyTemplate: PropTypes.func,
    buyLocalTemplate: PropTypes.func,
    getBuyState: PropTypes.func,
    newClassName: PropTypes.string,
    /**
     * 协议确认对象 protocol
     * @param {string} url 协议链接
     * @param {string} text 协议名
     */
    protocol: PropTypes.object,
    // 小游戏拥有状态
    getLotteryBuyList: PropTypes.func,
  };

  constructor() {
    super();
    this.state = {
      // 小游戏请求创建开关
      creatGameFlag: true,
      // 异步 是否禁止去制作
      btnDisabled: false,
      // 是否显示活动入口
      showActivity: false,
      // 是否正在请求查询活动是否开启的接口
      isLoading: false,
      // 活动文案
      activityText: '',
      // 活动url
      activityUrl: '',
      // 开通授权弹窗显示状态
      authWindowVisible: false,
    };
    this.authWinTimer = null;
    this.handleActivityBtn = this.handleActivityBtn.bind(this);
    this.toBuy = this.toBuy.bind(this);
  }

  sendComponent(opts) {
    const { data } = this.props;
    let { id, tplPrice, type, category } = data;
    if (!category) {
      category = 'CONTENT_TOPICS';
    }
    const clickfrom = StatParams.TPL_CATEGORY[category];
    let statObject = {
      id: opts.id,
      tplid: id,
      tpltype: StatParams.TPL_TYPE[type],
      tplprice: tplPrice > 0 ? '2' : '1',
      clickfrom,
    };
    // 小游戏时添加抽奖类型埋点字段
    if (category === 'RP_GAME') {
      statObject.lotteryid = this.props.data.lotteryId;
    }
    if (clickfrom === StatParams.TPL_CATEGORY.CONTENT_TOPICS) {
      statObject.topicid = window.location.pathname.split('/')[3];
    }

    sendStat('RP_STORE', opts.name, '点击量', Stat.ACTION_INIT, statObject);
  }

  // 是否使用优惠券
  isCounpon() {
    const { data = {}, coupon = {} } = this.props;
    const { tplPrice, tplOrganizePrice, minimumPrice } = data;
    const { couponPrice } = coupon;
    let discountPrice = +tplPrice;

    if (+tplOrganizePrice) {
      discountPrice = +tplOrganizePrice;
    }
    if (+minimumPrice < discountPrice) {
      discountPrice = +minimumPrice;
    }
    if (+couponPrice < discountPrice) {
      discountPrice = +couponPrice;
      return true;
    }
    return false;
  }

  // 获取 是否隐藏付费模板
  getPayTemplate(platformConfigInfo = null) {
    if (
      platformConfigInfo !== null &&
      platformConfigInfo !== 'unset' &&
      platformConfigInfo.hidePayInfo
    ) {
      const hidePayInfo = JSON.parse(platformConfigInfo.hidePayInfo);
      return hidePayInfo.hidePayTemplate;
    }
    return false;
  }

  // 去制作
  async toMake() {
    const {
      id,
      category = '',
      type,
      title = '',
      tplPrice,
      videoHost,
    } = this.props.data;
    const { protocol, userInfo } = this.props;

    this.sendComponent({
      id: 'web_mobanmarket_use_click',
      name: '模版中间页-立即使用',
    });

    sendStat('RP_STORE', '模版市场', '点击去制作', Stat.ACTION_CLICK, {
      id: 'web_mobanmarket_edit_click',
      os: window.browserInfo.os,
      browserVersion: window.browserInfo.browserVersion,
      userStatus: window.userStatus,
      url: window.location.href,
      tpl_id: this.props.data.id,
    });

    // fibo埋点
    statisticSDK.pushTemplateToMake({ title, tplPrice });

    //  账号封禁检查
    if (BLOCKED_CODE.includes(+userInfo.disabledState)) {
      return toast.show({
        type: 'error',
        msg: BLOCKED_TEXT.CREATE,
        delay: 2000,
      });
    }
    if (!acceptProto && protocol) {
      this.showAcceptTips.classList.add('game-proto-show');
      return false;
    } else if (protocol) {
      this.showAcceptTips.classList.remove('game-proto-show');
    }
    if (category === RP_GAME) {
      // this.jumpGameEditor();
      return;
    }

    // 隐藏付费模板 状态下  异步检测是否修改价格
    const { userId, organizeId, platformConfigInfo } = this.props.userInfo;
    const hideTemplate = this.getPayTemplate(platformConfigInfo);
    if (hideTemplate) {
      if (this.state.btnDisabled) return;
      const api = '/api/store/template/template';
      const res = await ajax.get(api, { id, userId, organizeId, category });
      // 若该模板为插件模板 则不校验模板价格 以及模板内部的付费素材
      const { pluginClassifyId } = res;
      if (!pluginClassifyId) {
        if (res) {
          const { tplPrice, materials } = res;
          if (
            !(tplPrice === 0 || tplPrice === null || tplPrice === undefined) ||
            materials !== 0
          ) {
            toast.show({
              type: 'error',
              msg: '该模板付费信息已调整,暂时无法使用',
              delay: 2000,
            });

            this.setState({ btnDisabled: true });
            return false;
          }
        }
      }
    }
    // return false;

    setTimeout(() => {
      gotoEditor(id, type, category, videoHost);
    }, 200);
  }

  // 跳转小游戏编辑器
  // async jumpGameEditor() {
  //   const { lotteryId, id } = this.props.data;
  //   const { userId, organizeId } = this.props.userInfo;
  //   const { creatGameFlag } = this.state;
  //   if (creatGameFlag === true) {
  //     this.setState({
  //       creatGameFlag: false,
  //     });
  //     const url = `/api/store/game/create`;
  //     const params = {
  //       userId,
  //       orgId: organizeId,
  //       prototypeId: id,
  //       lottertyTypeId: lotteryId,
  //     };
  //     try {
  //       const data = await ajax.post(url, params);
  //       if (data) {
  //         gotoGameEditor(data.id);
  //       } else {
  //         this.setState({
  //           creatGameFlag: true,
  //         });
  //       }
  //     } catch (e) {
  //       this.setState({
  //         creatGameFlag: true,
  //       });
  //     }
  //   }
  // }

  // 去购买
  async toBuy() {
    const {
      data,
      userInfo,
      coupon = {},
      buyTemplate,
      buyLocalTemplate,
      protocol,
    } = this.props;
    const { id, category, lotteryId } = data;
    const { couponId = '' } = coupon;
    const { userId, isYouzan, kdtId } = userInfo;

    sendStat('RP_STORE', '模版市场', '点击立即购买', Stat.ACTION_CLICK, {
      id: 'web_mobanmarket_buy_click',
      os: window.browserInfo.os,
      browserVersion: window.browserInfo.browserVersion,
      userStatus: window.userStatus,
      url: window.location.href,
      tpl_id: data.id,
    });

    // fibo埋点，不是小游戏模板的，点击立即购买发送埋点数据
    if (category !== RP_GAME) {
      this.sendFiboData('立即购买');
    }

    if (!acceptProto && protocol) {
      this.showAcceptTips.classList.add('game-proto-show');
      return false;
    } else if (protocol) {
      this.showAcceptTips.classList.remove('game-proto-show');
    }
    const showSSODialog = window.COMMON_NAVBAR.showSSODialog;
    if (!userId) {
      showSSODialog && showSSODialog('login', true);
    } else {
      this.sendComponent({
        id: 'web_mobanmarket_buy_click',
        name: '模版中间页-立即购买',
      });
      // 有赞单独处理逻辑
      if (isYouzan) {
        try {
          const res = await getYouzanBill(id, kdtId);
          window.open(res.payment_url);
          this.showPayDialog.call(this);
        } catch (err) {
          toast.show({ type: 'error', msg: err.message, delay: 2000 });
        }

        return;
      }
      // 兔展自己的处理逻辑
      if (category === LOCAL_TEMPLATE) {
        buyLocalTemplate({ id });
      } else {
        if (this.isCounpon()) {
          buyTemplate({ id, couponId });
        } else if (category === RP_GAME) {
          buyTemplate({ id, lotteryId });
        } else {
          buyTemplate({ id });
        }
      }
      this.showPayDialog.call(this);
    }
  }

  // 申请小游戏免费体验资格
  // async applyGameFreeTrial() {
  //   const { lotteryId, id } = this.props.data;
  //   const { userId, organizeId } = this.props.userInfo;
  //   const { protocol } = this.props;
  //   const url = `/api/store/game/getFreeTrial`;
  //   const params = cleanObj({
  //     userId,
  //     orgId: organizeId,
  //     protoTypeId: id,
  //     lotteryTypeId: lotteryId,
  //   });
  //   if (!acceptProto && protocol) {
  //     this.showAcceptTips.classList.add('game-proto-show');
  //     return false;
  //   } else if (protocol) {
  //     this.showAcceptTips.classList.remove('game-proto-show');
  //   }
  //   try {
  //     const data = await ajax.get(url, params);
  //     if (data) {
  //       this.toMake();
  //       this.props.getBuyState();
  //     }
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

  // 显示支付弹框
  showPayDialog() {
    const {
      getBuyState,
      getLotteryBuyList,
      data: { id, title },
      userInfo: { userId, userPfid, organizeId, organizationId },
    } = this.props;

    PayDialog.confirm({
      templateId: id,
      userId: userId,
      pfid: userPfid,
      userOrganize: organizeId,
      organizationId: organizationId,
      checkPayStatus: async () => {
        // 兔展自己的处理逻辑
        const { flag, price } = await getBuyState();
        const status = flag === '1';
        // 刷新小游戏拥有状态
        if (getLotteryBuyList) {
          await getLotteryBuyList();
        }
        if (status) {
          this.sendComponent({
            id: 'web_mobanmarket_buysucess_click',
            name: '模版中间页-购买成功',
          });
          statisticSDK.pushFiboTemplateBuy({ title, price });
        }
        return status;
      },
    });
  }

  // 发送fibo埋点数据
  sendFiboData(elementName) {
    const { data } = this.props;
    const { tplPrice, category, title, pluginId } = data;
    let content = `${title}`;
    // 由于在模板市场-推荐页面的时候，返回的模板数据中 category 为空字符串，
    // 所以这里需要加一个判断 pluginId 不存在的情况才能确定不是插件模板
    if (category !== CHAJIAN && !pluginId) {
      // 由于会员专区返回的数据中 tplPrice 为 null，所以增加 tplPrice === null 的判断
      const isFree = tplPrice === 0 || tplPrice === null;
      const price = isFree ? '免费' : '付费';
      content = `${title}-${price}`;
    }
    statisticSDK.pushCustomEvent('c_click', {
      c_elmname: elementName,
      c_elmcontent: content,
      c_money: '',
      c_elmtype: 'button',
      c_component: 'TemplateLayer',
    });
  }

  // 活动入口点击触发的函数
  handleActivityBtn() {
    const { activityUrl, activityText } = this.state;
    window.open(activityUrl, '_blank');
    this.sendFiboData(activityText);
  }

  // 显示开通权限弹窗
  handleShowAuthWindow = () => {
    clearTimeout(this.authWinTimer);
    const { authWindowVisible } = this.state;
    if (!authWindowVisible) {
      this.setState({
        authWindowVisible: true,
      });
    }
  };

  // 隐藏开通权限弹窗
  handleHideAuthWindow = () => {
    clearTimeout(this.authWinTimer);
    this.authWinTimer = setTimeout(() => {
      this.setState({
        authWindowVisible: false,
      });
    }, 300);
  };

  // 模板是否是免费的, 这个函数仅仅是为了判断是否展示活动入口用的
  isFree() {
    const { data = {}, coupon = {} } = this.props;
    const { tplPrice, tplOrganizePrice, minimumPrice } = data;
    const { couponPrice } = coupon;
    // 有一个是 0 的话证明该模板不需要花钱购买，默认不展示活动入口，
    const list = [tplPrice, tplOrganizePrice, minimumPrice, couponPrice];
    return list.includes(0);
  }

  // 获取活动详情
  async getActivityConfig() {
    try {
      this.setState({ isLoading: true });
      const res = await getActivityConfig();
      const config = res || {};
      this.setState({
        isLoading: false,
        showActivity: config.opened === true,
        activityText: config.text || '',
        activityUrl: config.jumpLink || '',
      });
    } catch (err) {
      this.setState({ isLoading: false });
    }
  }

  // 渲染活动链接，模板为插件的时候出现
  renderActivityLink() {
    const { showActivity, activityText, activityUrl } = this.state;
    if (showActivity && !!activityText && !!activityUrl) {
      return (
        <div className="activity-item" onClick={this.handleActivityBtn}>
          <img src={hotImgRight} />
          <span className="activity-text">{`${activityText} >>`}</span>
        </div>
      );
    }
    return null;
  }

  // 渲染活动时的按钮
  renderActivityBtns() {
    const { showActivity, activityText, activityUrl } = this.state;
    const isFree = this.isFree();
    if (showActivity && !isFree && !!activityText && !!activityUrl) {
      return (
        <div className="activity-btns-wrapper">
          <a className="buy-btn" onClick={this.toBuy}>
            立即购买
          </a>
          <a className="activity-btn" onClick={this.handleActivityBtn}>
            {activityText}
            <img src={hotImgLeft} className="hot-img" />
          </a>
        </div>
      );
    }
    return <a onClick={this.toBuy}>立即购买</a>;
  }

  componentDidMount() {
    this.getActivityConfig();
    const { category } = this.props.data;

    // 本地模版、企业模版不需要校验购买状态
    if (category === LOCAL_TEMPLATE || category === ENTERPRISE) {
      return;
    }
    this.props.getBuyState();
  }

  componentWillUnmount() {
    clearTimeout(this.authWinTimer);
    this.authWinTimer = null;
  }

  render() {
    const { authWindowVisible } = this.state;
    const showRabbitpre = isShowRabbitpre();
    const { data, buyState, newClassName = '', protocol } = this.props;
    const {
      tplPrice,
      category,
      tplShelf,
      pluginId,
      pluginOpen,
      orgTplFlag,
      hasAvailableCoupon,
    } = data;
    const { flag } = buyState;

    let protoHtmlContainer = null;
    if (protocol) {
      protoHtmlContainer = (
        <div className="game-proto">
          <input
            type="checkbox"
            defaultChecked={acceptProto}
            onClick={() => {
              acceptProto = !acceptProto;
            }}
          />
          <label />
          <p
            className="text"
            onClick={() => {
              window.open(protocol.url);
            }}>
            {protocol.text}
          </p>
          <p
            ref={node => {
              this.showAcceptTips = node;
            }}
            className="game-proto-tip">
            *请阅读并同意用户协议，方便您继续使用我们的服务
          </p>
        </div>
      );
    }

    // 下架模版
    if (tplShelf === '2') {
      return (
        <div className={`s-preview-buy-container`}>
          <a className="s-preview-buy-failed">该模板已下架</a>
        </div>
      );
    }

    // 包含插件且未开通插件权限的非企业模版（且未使用券购买的玩法模板）
    if (
      category !== ENTERPRISE &&
      !orgTplFlag &&
      pluginId &&
      !pluginOpen &&
      flag !== '1'
    ) {
      return (
        <>
          {hasAvailableCoupon && isOrgUser() ? (
            <div className="s-preview-buy-container" onClick={this.toBuy}>
              <a>立即购买</a>
            </div>
          ) : (
            <div
              className={`s-preview-buy-container ${newClassName} ${
                authWindowVisible ? 'is-hover' : ''
              }`}
              onMouseOver={this.handleShowAuthWindow}
              onMouseLeave={this.handleHideAuthWindow}>
              <a>立即开通</a>
              {protoHtmlContainer}
            </div>
          )}

          {authWindowVisible && showRabbitpre && (
            <div
              className="s-preview-qrcode-container"
              onMouseOver={this.handleShowAuthWindow}
              onMouseLeave={this.handleHideAuthWindow}>
              <div className="info-box">
                <div className="title">
                  扫一扫，申请开通体验权限
                  {this.renderActivityLink()}
                </div>
                {/* <p className="infos">
                  <i className="icon-phone" />
                  400-040-3488
                </p> */}
                <p className="infos">
                  <i className="icon-email" />
                  rabbitpre@tuzhanai.com
                </p>
              </div>
              <div className="qrcode-box">
                <img className="code" src={qrcodePng} />
              </div>
            </div>
          )}
        </>
      );
    }

    // 免费作品,企业专区作品和我的模版作品均可立即使用
    if (
      // 已开通的插件作品
      (pluginId && pluginOpen) ||
      // 免费作品
      tplPrice === 0 ||
      tplPrice === null ||
      // 企业专区作品
      category === ENTERPRISE ||
      // 我的模版作品
      category === MY_TPL ||
      // 已经购买
      flag === '1'
    ) {
      let btnText = '去制作';
      if (category === RP_GAME) {
        btnText = '立即使用';
      }
      return (
        <div className={`s-preview-buy-container ${newClassName}`}>
          <a
            className={`${this.state.btnDisabled ? 'to-make-disabled' : ''}`}
            onClick={debounce(this.toMake.bind(this), 500, true)}>
            {btnText}
          </a>
          {protoHtmlContainer}
        </div>
      );
    } else if ((!flag && category !== LOCAL_TEMPLATE) || this.state.isLoading) {
      return (
        <div className={`s-preview-buy-container ${newClassName}`}>
          <a>
            <span className="s-icon icon-waiting" />
          </a>
          {protoHtmlContainer}
        </div>
      );
    }

    // 是否第三方平台账号 自动生成订单去制作
    if (isAutoPay()) {
      return (
        <div className={`s-preview-buy-container ${newClassName}`}>
          <a onClick={debounce(this.toMake.bind(this), 500, true)}>去制作</a>
          {protoHtmlContainer}
        </div>
      );
    }

    // 小游戏购买按钮
    // if (category === RP_GAME) {
    //   let btnText = '立即购买';
    //   if (flag === '2') {
    //     btnText = '立即续费';
    //   }
    //   return (
    //     <div
    //       className={classnames(`s-preview-buy-container ${newClassName}`, {
    //         freetraial: typeof freeTrial === 'number' && flag !== '2',
    //       })}>
    //       <a onClick={this.toBuy}>{btnText}</a>
    //       {typeof freeTrial === 'number' && flag !== '2' ? (
    //         <FreeTrialBtn
    //           applyGameFreeTrial={this.applyGameFreeTrial.bind(this)}
    //           freeTrialFlag={freeTrial}
    //         />
    //       ) : (
    //         ''
    //       )}
    //       {protoHtmlContainer}
    //     </div>
    //   );
    // }

    return (
      <div className={`s-preview-buy-container ${newClassName}`}>
        {this.renderActivityBtns()}
      </div>
    );
  }
}

export default PreviewPrice;
